import { useEffect, useMemo } from 'react';

import { PageLoading } from '@/pages/PageLoading';
import { useIsLoading } from '@/shared/hooks/useIsLoading';
import { useProfileStore } from '@/shared/store/profileStore';

import { useGetConversationsListQuery } from '../api';
import { useGetChatProfileQuery } from '../api/get-chat-profile/hook';
import { Conversationitem } from '../components/ConversationItem/ConversationItem';
import { ChatHeader } from '../modules/ChatHeader';
import { ConversationsList } from '../modules/ConversationsList';
import { useChatStore } from '../store/chatStore';

export const ChatPage = () => {
  const { profile, currentSessionId } = useProfileStore();
  const { updateChatProfile } = useChatStore();

  const chatProfile = useGetChatProfileQuery({
    profileType: profile?.role!,
    profileId: currentSessionId?.toString()!
  });

  const isLoading = useIsLoading([chatProfile]);

  useEffect(() => {
    if (chatProfile.data?.data.chatProfileId) {
      updateChatProfile(chatProfile.data?.data);
    }
  }, [chatProfile.data?.data.chatProfileId]);

  const conversationList = useGetConversationsListQuery(
    {
      chatProfileId: chatProfile.data?.data.chatProfileId!
    },
    {
      options: {
        refetchInterval: 5000,
        refetchIntervalInBackground: true,
        retry: 3,
        enabled: !!chatProfile.data?.data.chatProfileId
      }
    }
  );

  const sortedConversations = useMemo(() => {
    const list = conversationList.data?.data ?? [];

    return [...list].sort((a, b) => {
      const aDate = new Date(a.lastMessage?.sentAt ?? a.createdAt).getTime();
      const bDate = new Date(b.lastMessage?.sentAt ?? b.createdAt).getTime();
      return bDate - aDate; // latest first
    });
  }, [conversationList.data?.data]);

  if (isLoading) return <PageLoading />;

  return (
    <div>
      {chatProfile.data?.data && (
        <ChatHeader profile={chatProfile.data?.data} />
      )}
      {conversationList.data?.data && (
        <ConversationsList
          conversations={sortedConversations}
          renderItem={Conversationitem}
        />
        // </ScrollArea>
      )}
    </div>
  );
};
